import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  language: 'en',
  notifications: [],
  theme: 'light',
  sidebarOpen: false
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    addNotification: (state, action) => {
      const notification = {
        id: Date.now(),
        type: action.payload.type || 'info',
        title: action.payload.title,
        message: action.payload.message,
        duration: action.payload.duration || 5000
      };
      state.notifications.push(notification);

      // Auto remove notification after duration
      if (notification.duration) {
        setTimeout(() => {
          removeNotification(notification.id);
        }, notification.duration);
      }
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    }
  }
});

export const {
  setLanguage,
  addNotification,
  removeNotification,
  setTheme,
  toggleSidebar,
  setSidebarOpen
} = uiSlice.actions;

// Selectors
export const selectLanguage = state => state.ui.language;
export const selectNotifications = state => state.ui.notifications;
export const selectTheme = state => state.ui.theme;
export const selectSidebarOpen = state => state.ui.sidebarOpen;

export default uiSlice.reducer;
